import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { CountdownTimerComponent } from '@frontend/sports/common/ui/countdown-timer';
import { WhenOverflowedDirective } from '@frontend/sports/common/ui/overflow';
import { ListItemComponent } from '@frontend/sports/common/ui/sports-list-items';
import { TextAutoScrollDirective } from '@frontend/sports/common/ui/text-auto-scroll';
import { TrackReferringACtionDirective } from '@frontend/sports/tracking/feature';
import { DsButton } from '@frontend/ui/button';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsTabsModule } from '@frontend/ui/tabsgroup';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { RaceViewBestOddsBadgeComponent } from '../best-odds-guarantee/race-view-best-odds-badge.component';
import { TranslationToStringPipe } from '../cds/translation.pipe';
import { ErrorComponent } from '../common/error/error.component';
import { CrmPromotionContainerComponent } from '../crm-promotion-container/crm-promotion-container.component';
import { BadgeComponent } from '../crm-promotion/badge.component';
import { CrmPromotionModule } from '../crm-promotion/crm-promotion.module';
import { HelpBoxComponent } from '../help-box/help-box.component';
import { NavigationCoreModule } from '../navigation-core/navigation-core.module';
import { GreyhoundsMeetingAllComponent } from '../racing/components/greyhounds/greyhounds-meeting/greyhounds-meeting-all.component';
import { GreyhoundsRaceDetailsComponent } from '../racing/components/greyhounds/greyhounds-race-details/greyhounds-race-details.component';
import { GreyhoundsRaceDetailsResolver } from '../racing/components/greyhounds/greyhounds-race-details/greyhounds-race-details.resolver';
import { TabBarModule } from '../tab-bar/tab-bar.module';
import { AntepostFixtureListComponent } from './components/antepost-fixture-list/antepost-fixture-list.component';
import { AntepostMarketComponent } from './components/antepost-fixture/antepost-market.component';
import { GreyhoundsErrorBreadCrumbComponent } from './components/greyhounds/greyhounds-error/greyhounds-error-breadcrumb.component';
import { GreyhoundsMeetingAllResolver } from './components/greyhounds/greyhounds-meeting/greyhounds-meeting-all.resolver';
import { GreyhoundsDayOfRaceComponent } from './components/greyhounds/greyhounds-today/greyhounds-today.component';
import { MeetingSwitcherToggleComponent } from './components/greyhounds/meeting-switcher-toggle/meeting-switcher-toggle.component';
import { HorsesForecastComponent } from './components/horses-forecast/horses-forecast.component';
import { HorsesMeetingAllComponent } from './components/horses-meeting/horses-meeting-all.component';
import { HorsesMeetingAllRacingPostResolver, HorsesMeetingAllResolver } from './components/horses-meeting/horses-meeting-all.resolver';
import { HorsesRaceDetailsComponent } from './components/horses-race-details/horses-race-details.component';
import { HorsesRaceDetailsResolver } from './components/horses-race-details/horses-race-details.resolver';
import { HorsesRaceTopnavComponent } from './components/horses-race-topnav/horses-race-topnav.component';
import { HorsesTodayComponent } from './components/horses-today/horses-today.component';
import { HorsesTomorrowComponent } from './components/horses-tomorrow/horses-tomorrow.component';
import { HorsesRaceWinMarketComponent } from './components/horses-win-market/horses-race-win-market.component';
import { RacingCommonModule } from './racing-common.module';
import { RacingRoutingModule } from './racing-routing.module';
import { GreyhoundRaceDetailsBreadcrumbsResolver } from './services/greyhound-race-details-breadcrumbs.resolver';
import { HorsesRaceDetailsBreadcrumbsResolver } from './services/horses-race-details-breadcrumbs.resolver';

export { GreyhoundsMeetingAllComponent } from './components/greyhounds/greyhounds-meeting/greyhounds-meeting-all.component';

@NgModule({
    imports: [
        AutomationModule,
        RaceViewBestOddsBadgeComponent,
        TranslationToStringPipe,
        CommonModule,
        CrmPromotionContainerComponent,
        CrmPromotionModule,
        NavigationCoreModule,
        RacingCommonModule.forChild(),
        RacingRoutingModule,
        TabBarModule,
        ErrorComponent,
        TextAutoScrollDirective,
        CountdownTimerComponent,
        WhenOverflowedDirective,
        BadgeComponent,
        HelpBoxComponent,
        IconCustomComponent,
        DsButtonIcon,
        DsTabsModule,
        DsButton,
        ListItemComponent,
        TrackReferringACtionDirective,
    ],
    declarations: [
        AntepostFixtureListComponent,
        HorsesMeetingAllComponent,
        HorsesRaceDetailsComponent,
        HorsesRaceTopnavComponent,
        HorsesTodayComponent,
        HorsesTomorrowComponent,
        GreyhoundsDayOfRaceComponent,
        GreyhoundsRaceDetailsComponent,
        GreyhoundsMeetingAllComponent,
        MeetingSwitcherToggleComponent,
        GreyhoundsErrorBreadCrumbComponent,
    ],
    providers: [
        HorsesMeetingAllResolver,
        HorsesMeetingAllRacingPostResolver,
        HorsesRaceDetailsResolver,
        HorsesRaceDetailsBreadcrumbsResolver,
        GreyhoundsMeetingAllResolver,
        GreyhoundsRaceDetailsResolver,
        GreyhoundRaceDetailsBreadcrumbsResolver,
    ],
})
export class RacingModule {
    readonly horsesRaceWinMarketComponent = HorsesRaceWinMarketComponent;
    readonly horsesForecastComponent = HorsesForecastComponent;
    readonly antepostMarketComponent = AntepostMarketComponent;
}
